import { Entity } from '@core/entities/entity'
import { IOpenCheckInsStats } from './IOpenCheckInsStats'

export class OpenCheckInsStats extends Entity<IOpenCheckInsStats> {
  checkedInCount: number
  overdueCheckOutsCount: number
}
